// extracted by mini-css-extract-plugin
export default {"eachMonth":"MonthlyRevenue_eachMonth__f1qGs","eachCol":"MonthlyRevenue_eachCol__PnVho"};